import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { Download, Monitor, Smartphone, Apple, AlertTriangle } from "lucide-react";

const APP_URL = process.env.REACT_APP_BACKEND_URL;
const LOGO_URL = "https://customer-assets.emergentagent.com/job_a6fd91e7-1ad0-4cf0-91ce-b769f9bab27a/artifacts/m0y29wqk_Sem%20T%C3%ADtulo.png";

export default function DownloadApp() {
  const openApp = () => {
    window.open(APP_URL, "_blank");
  };

  return (
    <div className="space-y-8" data-testid="download-page">
      {/* Header */}
      <div>
        <h1 className="font-chivo text-3xl md:text-4xl font-bold tracking-tight text-foreground flex items-center gap-3">
          <Download className="h-8 w-8" />
          Descarregar App
        </h1>
        <p className="text-muted-foreground mt-2">
          Instale o EP3D MES nos seus dispositivos.
        </p>
      </div>

      {/* 3 Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

        {/* Windows Card */}
        <Card className="border border-border" data-testid="card-windows">
          <CardContent className="pt-6 space-y-5">
            {/* Platform Title */}
            <div className="flex items-center gap-2 text-lg font-bold text-foreground">
              <Monitor className="h-5 w-5 text-blue-500" />
              Windows
            </div>

            {/* App Info Row */}
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="EP3D" className="h-12 w-12 rounded-xl bg-slate-900 p-1 object-contain" />
              <div>
                <p className="font-bold text-foreground">EP3D MES</p>
                <p className="text-xs text-muted-foreground">v1.0.0 | ~111 MB</p>
              </div>
            </div>

            {/* Steps */}
            <div className="space-y-2 text-sm text-muted-foreground">
              <p>1. Descarregue o ficheiro <strong className="text-foreground">ZIP</strong></p>
              <p>2. Extraia a pasta</p>
              <p>3. Execute <strong className="text-foreground">"EP3D Producao.exe"</strong></p>
              <p>4. Fica na <strong className="text-foreground">barra de tarefas</strong> e <strong className="text-foreground">notificações</strong></p>
            </div>

            {/* Download Button */}
            <a
              href="/downloads/EP3D-Producao-Windows.zip"
              download="EP3D-Producao-Windows.zip"
              className="block"
            >
              <Button className="w-full gap-2 bg-blue-600 hover:bg-blue-700 text-white h-11" data-testid="download-windows-btn">
                <Download className="h-4 w-4" />
                Descarregar para Windows
              </Button>
            </a>

            {/* Compat Badge */}
            <div className="text-center">
              <Badge variant="outline" className="text-xs text-muted-foreground font-normal">
                Windows 10/11 (64-bit)
              </Badge>
            </div>
          </CardContent>
        </Card>

        {/* Android Card */}
        <Card className="border border-border" data-testid="card-android">
          <CardContent className="pt-6 space-y-5">
            <div className="flex items-center gap-2 text-lg font-bold text-foreground">
              <Smartphone className="h-5 w-5 text-green-600" />
              Android
            </div>

            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="EP3D" className="h-12 w-12 rounded-xl bg-slate-900 p-1 object-contain" />
              <div>
                <p className="font-bold text-foreground">EP3D MES</p>
                <p className="text-xs text-muted-foreground">PWA | Instalação rápida</p>
              </div>
            </div>

            <div className="space-y-2 text-sm text-muted-foreground">
              <p>1. Abra o link no <strong className="text-foreground">Chrome</strong></p>
              <p>2. Menu (3 pontos) no canto superior</p>
              <p>3. Toque <strong className="text-foreground">"Instalar aplicação"</strong></p>
              <p>4. Confirme a instalação</p>
            </div>

            <Button
              className="w-full gap-2 bg-green-600 hover:bg-green-700 text-white h-11"
              onClick={openApp}
              data-testid="install-android-btn"
            >
              <Download className="h-4 w-4" />
              Instalar no Android
            </Button>

            <div className="text-center">
              <Badge variant="outline" className="text-xs text-muted-foreground font-normal">
                Android 5.0+ (Chrome)
              </Badge>
            </div>
          </CardContent>
        </Card>

        {/* iPhone Card */}
        <Card className="border border-border" data-testid="card-iphone">
          <CardContent className="pt-6 space-y-5">
            <div className="flex items-center gap-2 text-lg font-bold text-foreground">
              <Apple className="h-5 w-5 text-gray-800" />
              iPhone / iPad
            </div>

            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="EP3D" className="h-12 w-12 rounded-xl bg-slate-900 p-1 object-contain" />
              <div>
                <p className="font-bold text-foreground">EP3D MES</p>
                <p className="text-xs text-muted-foreground">PWA | Safari</p>
              </div>
            </div>

            <div className="space-y-2 text-sm text-muted-foreground">
              <p>1. Abra o link no <strong className="text-foreground">Safari</strong></p>
              <p>2. Toque no ícone <strong className="text-foreground">Partilhar</strong></p>
              <p>3. Deslize e toque <strong className="text-foreground">"Ecrã Inicial"</strong></p>
              <p>4. Confirme com <strong className="text-foreground">"Adicionar"</strong></p>
            </div>

            <Button
              className="w-full gap-2 bg-slate-800 hover:bg-slate-900 text-white h-11"
              onClick={openApp}
              data-testid="install-iphone-btn"
            >
              <Download className="h-4 w-4" />
              Instalar no iPhone
            </Button>

            <div className="text-center">
              <Badge variant="outline" className="text-xs text-muted-foreground font-normal">
                iOS 16.4+ (Safari)
              </Badge>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Yellow Warning Box */}
      <div className="bg-amber-50 border border-amber-300 rounded-xl p-4 flex gap-3">
        <AlertTriangle className="h-5 w-5 text-amber-600 shrink-0 mt-0.5" />
        <div>
          <p className="font-bold text-amber-800 text-sm">Nota sobre o Windows</p>
          <p className="text-sm text-amber-700 mt-1">
            O Windows pode mostrar um aviso "Windows protegeu o seu PC" ao executar. Clique em <strong>"Mais informações"</strong> e depois <strong>"Executar mesmo assim"</strong>. Isto acontece porque a app não tem certificado digital (normal para apps internas).
          </p>
        </div>
      </div>

      {/* Manual de Instruções */}
      <Card className="border border-border">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="font-bold text-foreground">Manual de Instruções (PDF)</p>
              <p className="text-sm text-muted-foreground">Guia completo para download e impressão</p>
            </div>
            <a href="/downloads/EP3D-Producao-Manual-Instrucoes.pdf" download="EP3D-Producao-Manual-Instrucoes.pdf">
              <Button variant="outline" className="gap-2" data-testid="download-manual-btn">
                <Download className="h-4 w-4" />
                Descarregar Manual (PDF)
              </Button>
            </a>
          </div>
        </CardContent>
      </Card>

      <Card className="border border-border">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="font-bold text-foreground">Manual Interativo (Online)</p>
              <p className="text-sm text-muted-foreground">Manual com imagens e navegação — abre no browser</p>
            </div>
            <a href="/manual.html" target="_blank">
              <Button className="gap-2 bg-amber-500 hover:bg-amber-600 text-white" data-testid="open-manual-online-btn">
                <Download className="h-4 w-4" />
                Abrir Manual Online
              </Button>
            </a>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
